import { render, staticRenderFns } from "./DependentCard.vue?vue&type=template&id=a0d9e570&scoped=true"
import script from "./DependentCard.vue?vue&type=script&lang=js"
export * from "./DependentCard.vue?vue&type=script&lang=js"
import style0 from "./DependentCard.vue?vue&type=style&index=0&id=a0d9e570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d9e570",
  null
  
)

export default component.exports